export default __webpack_public_path__ + "static/media/03.30ae8c33.jpg";